import React, { useLayoutEffect, useRef } from "react";
import { gsap } from "gsap";

const poses = {
  home: { label: "Home", k: [0, 0, 0], q: [0, 0, 0] },
  about: { label: "About", k: [-8, -7, -2], q: [8, 8, 2] },
  stack: { label: "Stack", k: [7, -10, 3], q: [-7, 10, -3] },
  experience: { label: "Experience", k: [-5, 9, -2], q: [7, -8, 2] },
  projects: { label: "Projects", k: [9, 4, 2], q: [-9, -4, -2] },
  contact: { label: "Contact", k: [0, -5, 0], q: [0, 5, 0] },
};

export function SignatureMark({ activeSection }) {
  const kRef = useRef(null);
  const qRef = useRef(null);
  const pose = poses[activeSection] || poses.home;

  useLayoutEffect(() => {
    const reduceMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    const duration = reduceMotion ? 0 : 0.9;
    const common = { duration, ease: "power3.inOut", transformOrigin: "50% 50%" };
    const kTween = gsap.to(kRef.current, { x: pose.k[0], y: pose.k[1], rotation: pose.k[2], ...common });
    const qTween = gsap.to(qRef.current, { x: pose.q[0], y: pose.q[1], rotation: pose.q[2], ...common });

    return () => {
      kTween.kill();
      qTween.kill();
    };
  }, [pose]);

  return (
    <div className="signature-mark" aria-hidden="true">
      <div className="signature-mark__letters">
        <span ref={kRef}>K</span>
        <span ref={qRef}>Q</span>
      </div>
      <small>{pose.label}</small>
    </div>
  );
}
